const FormInputField = ({
    label,
    required,
    type = "text",
    name,
    value,
    onChange,
    onBlur,
    placeholder,
    errorText,
    extraRightElement,
    fullWidth = false,
}) => (
    <div className={`${fullWidth ? "col-12" : "col-lg-6"} mb-2 my-4`}>
        <div className="mb-3 d-flex flex-column align-items-start w-100">
            <label className="form-label me-1 fs-5 text-black mx-2">
                {label}
                {required && <span className="required"> *</span>}
            </label>
            <input
                type={type}
                className="form-control"
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
            />
            {errorText && (
                <span className="text-danger mt-1">
                    {errorText}
                </span>
            )}
            {extraRightElement}
        </div>
    </div>
);

export default FormInputField;